import { UnitSchema } from './unit';

export const EditableUnitFieldsSchema = UnitSchema.omit({ id: true, isLocked: true });
